import { useAuth } from '@/store/auth';
import { AccessPermission, ResourceAction } from '@/types/auth';

export function useHasAccess(action: ResourceAction) {
  const { user } = useAuth();

  if (!user) return false;

  return AccessPermission[user.role].includes(action);
}
